import type { CellConfig } from "@topi/shared/cell/cell-config";

const websiteBase = "https://www.topi.eu";

export const cellConfig: CellConfig = {
  websiteBase,
  topiPortal: "https://rentwith.topi.eu/",
  emails: {
    support: "support@topi.eu",
    sales: "sales@topi.eu",
    emergencyContact: "offer@topi.eu",
  },
  imprint: {
    en: `${websiteBase}/en/imprint`,
    de: `${websiteBase}/de/imprint`,
  },
  faqs: {
    en: `${websiteBase}/en/faqs`,
    de: `${websiteBase}/de/faqs`,
  },
  renters: {
    en: `${websiteBase}/en/rent`,
    de: `${websiteBase}/de/rent`,
  },
  showsTrustpilot: true,
};
